module.exports = __webpack_public_path__ + "img/big-img-kuang.1d1ee126.png";